export default __webpack_public_path__ + "static/image166-83eea82eb231f356a33c30ac2857bacf.jpg";